import React from "react";
import {
	TouchableOpacity,
	StyleSheet,
	View,
} from "react-native";

import Style from "ae-style";

import StyledText from "../Base/StyledText";
import StyledIcon from "../Base/StyledIcon";
import { useIdPrefix } from "@aetonix/hooks";

const styles = StyleSheet.create({
	container: {
		flexDirection: "row",
		alignItems: "center",
		paddingVertical: Style.layout.paddingSmall
	},
	normal: {
		borderColor: Style.look.text
	},
	contrast: {
		borderColor: Style.look.contrast.text
	},
	marginSmall: {
		marginRight: Style.layout.marginSmall,
		marginLeft: Style.layout.marginSlim / 4
	}
});

export default function ListAdd(props){
	const idPrefix = useIdPrefix();
	const title = props.title;
	const onPress = props.onPress;
	const contrast = props.contrast;
	const disabled = props.disabled;
	const additionalStyle = props.style;
	const id = props.id;

	if(disabled) return null;

	const borderColor = contrast ? styles.contrast : styles.normal;
	const iconStyle = [borderColor, styles.marginSmall];

	const content = (
		<View style={[styles.container, additionalStyle]}>
			<StyledIcon style={iconStyle} contrast={contrast} largeHeading name="aeto-add" />
			<StyledText testID={id + "_text"} contrast={contrast} bold>
				{title}
			</StyledText>
		</View>
	);

	if(!onPress) return content;

	return (
		<TouchableOpacity testID={`${idPrefix}${idPrefix ? "-" : ""}${id}`} accessibilityComponentType="button" onPress={onPress}>
			{content}
		</TouchableOpacity>
	);
}